<div *ngIf="campaign" class="row mb-3 py-4">
  <div class="col-12 col-lg-6">
    <div (click)="gotoDetail(campaign)" [background-image]="campaign.headerImage" class="card-page__header mouse_pointer"
         role="link" tabindex="0" (keydown.enter)="gotoDetail(campaign)" [attr.aria-label]="'View storyboard for ' + campaign.title">
      <div class="card-page__header-inner">
        <div class="d-flex justify-content-between align-items-start">
          <h4 class="mb-0">{{campaign.title}}</h4>
          <span class="campaign-item__story-count" *ngIf="campaign.story_count != null">
            {{campaign.story_count}} {{campaign.story_count === 1 ? 'Story' : 'Stories'}}
          </span>
        </div>
        <p class="campaign-item__desc">{{campaign.description}}</p>
      </div>
    </div>
    <div class="card-page__body">
      <div class="form-inline campaign-item__actions">
        <div class="campaign-item__btn" style="z-index: 999;">
          <a [routerLink]="['/c/' + campaign.companySlug + '/campaigns/' + campaign.slug]"
             [style.background]="viewStoryboardBtn"
             [style.borderColor]="viewStoryboardBtn"
             [style.color]="txtsubmit"
             class="btn btn-sm mr-2 view-storyboard-btn">View Storyboard</a>
        </div>
        <ng-container *ngIf="campaign && !campaign.interview_style">
          <div class="campaign-item__btn" style="z-index: 999;" *ngIf="campaign.daysLeft >= 0">
            <a [routerLink]="['/t/' + campaign.companySlug + '/testimonial/create']" [queryParams]="{cs: campaign.slug}" [style.background]="btnsubmit"  [style.color]="txtsubmit" class="btn btn-sm">Submit Story</a>
          </div>
        </ng-container>

        <ng-container *ngIf="campaign && campaign.interview_style">
          <div class="campaign-item__btn" style="z-index: 999;" *ngIf="campaign.daysLeft >= 0">
            <a (click)="navgateToInterviewStyle(campaign)"
               class="btn btn-sm" [style.background]="btnsubmit"  [style.color]="txtsubmit" style="color: #fff !important">Submit Story</a>
          </div>
        </ng-container>
        <div class="spacer"></div>
        <ng-container *ngIf="campaign.daysLeft >= 0">
        <span class="tag-icon text-white">
          <svg role="img">
            <use xlink:href="#icon-time"></use>
          </svg>
          <span class="text">{{campaign.daysLeft}} days <span class="d-none d-md-inline">left</span></span>
        </span>
        </ng-container>
        <ng-container *ngIf="campaign.daysLeft < 0">
        <span class="tag-icon text-white">
          <svg role="img">
            <use xlink:href="#icon-time"></use>
          </svg>
          <span class="text">Finished</span>
        </span>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="col-12 col-lg-6 px-3 px-lg-0">
    <div class="campaign-item__none" *ngIf="(!campaign.stories || campaign.stories.length == 0) && campaign.daysLeft >= 0">
      <div class="text-center pt-11">
        <h5>No stories.</h5>
      </div>
    </div>
    <div class="campaign-item__none" *ngIf="(!campaign.stories || campaign.stories.length == 0) && campaign.daysLeft < 0">
      <div class="text-center pt-11">
        <h5>No stories.</h5>
      </div>
    </div>
    <div class="campaign-item__detail" *ngIf="campaign.stories && campaign.stories.length > 0">
      <table class="newest-stories">
        <colgroup>
          <col/>
          <col style="width: 33%;"/>
        </colgroup>
        <thead>
        <tr>
          <th colspan="2">Recent Stories</th>
        </tr>
        </thead>
      </table>
      <div class="table-scroll-y scrollbar-macosx">
        <table class="newest-stories">
          <colgroup>
            <col/>
            <col style="width: 33%;"/>
          </colgroup>
          <tbody>
          <tr *ngFor="let story of campaign.stories" class="mouse_pointer"
              [routerLink]="'/c/' + getSlugCompany(story) + '/' + story.slug"
              [queryParams]="{public: 1}">
            <td style="text-align: left; padding: 0.25rem 2rem .25rem 1rem;"><span style="color: #007bff;">{{story.title}}</span></td>
            <td style="text-align: right; min-width: 100px; padding: 0.25rem 2rem .25rem 1rem;">
              <strong style="vertical-align: middle;">{{story.author.displayName}}</strong>
              <div [background-image]="getauthor(story?.author?.avatar)" class="avatar avatar--x-sm" style="display: inline-block; margin-left: 8px; vertical-align: middle;"></div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
